import { API_URLS_LIST } from '@config/api-config';
import axiosInstanceNoSpinner from '@services/api/axios-wrapper-nospinner-service';
import axiosInstance from '@services/api/axios-wrapper-service';
import { useGlobalStore } from '@services/store/global-store';

export const getMemberRoster = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.memberListing, request, {
    timeout: 300000 // Override timeout to 5 min (300000ms)
  });
};

export const getCCEEvents = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.getCCEEvents, request);
};

export const getMemberById = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.getMemberById, {
    ...request,
    userRole: useGlobalStore.getState().userDetails.userInformation?.userRole,
    lpChatEnabled: useGlobalStore.getState().preference?.member?.livePersonChat,
    npiID: useGlobalStore.getState().userDetails.userInformation?.npiId
  });
};



export const searchMember = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.searchMember, request);
};

export const lookupMemberById = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.lookupMemberById, request);
};

export const lookupMemberByIdSelfReg = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.lookupMemberByIdSelfReg, request);
};

export const lookupMemberByIdForEnrollment = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.lookupMemberByIdForEnrollment, request);
};

export const careGiverMembers = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.getCareGiverMembers, request);
};


export const getClaimsListing = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.getClaimsListing, request,  {
    timeout: 300000 // Override timeout to 5 min (300000ms)
  });
};

export const getClaimDetails = (
  memberId: string,
  claimId: string,
  sensitiveClaimId: string,
  claimDetails: any,
  supressSudSrhSensitiveInfo: any
): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.getClaimDetails, {
    memberId: memberId,
    claimId: claimId,
    sensitiveClaimId: sensitiveClaimId,
    claimDetails: claimDetails,
    supressSudSrhSensitiveInfo: supressSudSrhSensitiveInfo
  });
};

export const getHealthTrends = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.getHealthTrends, request);
};

export const addMembertoHip = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.addMembertoHip, request);
};

export const getAlertsById = (request: any): Promise<any> => {
  return axiosInstanceNoSpinner.post(API_URLS_LIST.getCCEEvents, request);
};

export const getAnthemCareTeams = (memberId: string): Promise<any> => {
  return axiosInstanceNoSpinner.post(API_URLS_LIST.getAnthemCareTeams, {
    memberId: memberId
  });
};

export const getMemberProgramsAndWaivers = (hcid: string): Promise<any> => {
  return axiosInstanceNoSpinner.post(
    API_URLS_LIST.getMemberProgramsAndWaivers,
    { hcid: hcid }
  );
};

export const getMemberConsent = (hcid: string): Promise<any> => {
  return axiosInstanceNoSpinner.post(API_URLS_LIST.getMemberConsent, {
    hcid: hcid
  });
};

export const getWellnessBenefitsById = (mcid: string): Promise<any> => {
  return axiosInstanceNoSpinner.post(API_URLS_LIST.getWellnessBenefitsById, {
    mcid: mcid
  });
};

export const getSocialDeterminantInfo = (
  zipCd: string,
  sourceSystem: string
): Promise<any> => {
  return axiosInstanceNoSpinner.post(API_URLS_LIST.getSocialDeterminantInfo, {
    zipCode: zipCd,
    sourceSystem: sourceSystem
  });
};

export const getOpportunities = (request: any): Promise<any> => {
  return axiosInstanceNoSpinner.post(API_URLS_LIST.getOpportunities, request);
};

export const getMemberPCPDetails = (pcpReq: any): Promise<any> => {
  return axiosInstanceNoSpinner.post(API_URLS_LIST.getMemberPCPDetails, pcpReq);
};

export const getCareGaps = (request: any): Promise<any> => {
  return axiosInstanceNoSpinner.post(API_URLS_LIST.getCareGaps, request);
};
export const updateMember = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.updateMember, request);
};

export const getImmunizations = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.getImmunizations, request);
};

export const getImmunizationHistory = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.getImmunizationHistory, request);
};

export const getMemberAssessments = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.getMemberAssessments, request);
};
export const getMemberViewAssessment = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.getMemberViewAssessment, request);
};
export const getDocumentsById = (
  memberId: string,
  filterDocType: string
): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.getDocumentsById, {
    memberId: memberId,
    filterDocType: filterDocType
  });
};
export const getDocumentByDocId = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.getDocumentByDocId, request);
};
export const saveMemberDoc = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.saveMemberDoc, request);
};

export const getStaticCodeValue = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.getStaticCodeValue, request);
};

export const addImmunization = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.addImmunization, request);
};

export const getTestEvaluationHistory = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.getTestEvaluationHistory, request);
};

export const getMemberCareNotes = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.getMemberCareNotes, request);
};

export const saveMemberCareNote = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.saveMemberCareNote, request);
};

export const createAttestation = (data: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.createAttestation, data);
};

export const getMedicationHistory = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.getMedicationHistory, request);
};

export const getMedications = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.getMedications, request);
};
export const getMedicationStaticCodes = (memberId: string) => {
  return axiosInstance.post(API_URLS_LIST.getMedicationStaticCodes, {
    memberId: memberId
  });
};

export const postMedications = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.postMedications, request);
};

export const getOverutilization = (memberId: string) => {
  return axiosInstance.post(API_URLS_LIST.getOverutilization, {
    memberId: memberId
  });
};
export const getDrugInteractionsLatest = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.getDrugInteractionsLatest, request);
};
export const getDrugs = (memberId: string, drugName: string) => {
  return axiosInstance.post(API_URLS_LIST.getDrugs, {
    memberId: memberId,
    drugName: drugName
  });
};

export const getCriticalIncidentDetails = (
  caseId: string,
  type: string
): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.getCriticalIncidentDetails, {
    caseId: caseId,
    eventType: type
  });
};

export const saveGoodToKnow = (request: any) => {
  return axiosInstance.post(API_URLS_LIST.saveGoodToKnow, request);
};

export const getQuestionnaire = (req: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.getQuestionnaire, req);
};
export const getQuestionnaireResponse = (req: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.getQuestionnaireResponse, req);
};
export const saveQuestionnaires = (req: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.saveQuestionnaire, req);
};

export const putQuestionnaires = (req: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.putMemberAssessments, req);
};

export const getQuestionnaireList = (): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.getQuestionnaireList, {});
};

export const deleteAssessment = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.deleteAssessment, request);
};

export const saveAppealGrievance = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.saveAppealGrievance, request);
};

export const uploadAppealGrievanceDoc = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.uploadAppealGrievanceDoc, request, {
    timeout: 300000 // Override timeout to 5 min (300000ms)
  });
};

export const enrollMember = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.enrollMember, request);
};

export const addMemberCommunication = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.addMemberCommunication, request);
};

export const submitRRTForm = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.submitRRTForm, request);
};

export const getLtssProgramDetails = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.getLtssProgramDetails, request);
};

export const saveChildDetailsForMbrAttribution = (request: any): Promise<any> => {
  return axiosInstance.post(API_URLS_LIST.saveChildDetailsForMbrAttribution, request);
};

export const getEncrptedHcid = (hcid: string): Promise<any> => {
  return axiosInstanceNoSpinner.post(
    API_URLS_LIST.getEncryptedHcid,
    { data: hcid }
  );
};
